export default __webpack_public_path__ + "static/media/ShMunAnimatedGif-inside.aab43531.gif";